<template>

  <md-autocomplete v-model="selectedValue" 
                   @md-selected="handleItemSelected"  
                   @md-changed="handleItemChanged"
                   :md-options="options"
     >
    <label v-if="label">{{label}}</label>

    <template slot="md-autocomplete-item" slot-scope="{ item, term }">
      <md-highlight-text :md-term="term">{{item}}</md-highlight-text>
    </template>

    <template slot="md-autocomplete-empty" slot-scope="{ term }">
      No item matching "{{ term }}" were found.
    </template>

  </md-autocomplete>

</template>
<script>
  import { mapGetters } from 'vuex';

  export default {
    props: {
      label: String,
      value: String,
      options: Array,
      onItemChanged: Function,
    },
    data: () => ({
      selectedValue: null,
    }),
    computed: {
      ...mapGetters([
        'getSTCDriverGroup',
      ]),
      getOptions() {
        if (this.Options) {
          //console.log(`this.Options=${JSON.stringify(this.Options)}`);
          return this.Options;
        }
        return this.getSTCDriverGroup();
      },
    },
    watch: {
      value(val) {
        this.selectValue = val;
      },
      selectedValue(val) {
        if (_(this.options).contains(val)) {
          this.$emit('input', val);
        } else {
          this.$emit('input', null);
        }
      },
    },
    mounted() {
      //console.log("mount: " + JSON.stringify(this.Options));
      this.$nextTick(() => {
        if (this.value) {
          this.selectedValue = this.value;
        }
      });
    },
    methods: {
      clear() {
        this.selectedValue = "";
      },
      handleDriverGroupSelected(id) {
        //console.log("auto complete select id: " + id);
        this.selectedValue = id;
      },
      handleItemSelected(item) {
        if (this.onItemChanged && _.isFunction(this.onItemChanged)) {
          //console.log("in handle select: stc driver group");
          //console.log(item);
          this.onItemChanged(item);
        }
      },
      handleItemChanged(item) {
        //console.log("handle item change");
        if (this.onItemChanged && _.isFunction(this.onItemChanged)) {
          //console.log("in handle select: stc driver group");
          //console.log(item);
          this.onItemChanged(item);
        }
        
      },
    },
  }

</script>
